import gql from 'graphql-tag'

export const GET_SUPPLIERS = gql`
  query(
    $page: Int 
    $perPage: Int
    $orderBy: SupplierOrderBy 
  ){
    suppliers(
      page: $page, 
      perPage: $perPage
      orderBy: $orderBy
    ) {
      hasNextPage
      nodes {
        id
        name
      }
    }
  }
`

export default {
  GET_SUPPLIERS

}
